import React, {Component} from 'react';
import './CommunityMembersPage.css';
import {getAdmins} from './community.selectors';
import {Link} from 'react-router-dom';
import './CommunityAdminList.css';
import Avatar from '../widgets/Avatar';
import {connect} from 'react-redux';
import {chatActions} from '../user';
import Icon from '../widgets/Icon';
import FancyLink from '../widgets/FancyLink';

class CommunityAdminList extends Component {
	render() {
		const {sessionProvider} = this.props;

		const admins = getAdmins(this.props);

		const sessionUserUuid = sessionProvider && sessionProvider.user && sessionProvider.user.uuid;

		return sessionProvider && admins ? (
			<div className="CommunityAdminList">
				Administered by;
				<ul>
					{admins.map((adminMember, idx) =>
						adminMember && adminMember.user ? (
							<li key={idx}>
								<Link to={`/@${adminMember.profile.uniqueName}`}>
									<Avatar provider={adminMember} size={24} />
									<span>
										{adminMember.user.firstname && adminMember.user.lastname
											? `${adminMember.user.firstname} ${adminMember.user.lastname}`
											: 'New user'}
									</span>
								</Link>
								{sessionUserUuid && sessionUserUuid !== adminMember.user.uuid ? (
									<FancyLink to={`/chats/${adminMember.user.uuid}`}>
										<Icon name="message" />
										<span>Open chat</span>
									</FancyLink>
								) : (
									undefined
								)}
							</li>
						) : (
							undefined
						)
					)}
				</ul>
			</div>
		) : null;
	}
}

const ConnectedCommunityAdminList = connect(
	({community, session}) => ({
		community,
		sessionProvider: session && session.current
	}),
	dispatch => ({
		openChat: provider => dispatch(chatActions.open(provider))
	})
)(CommunityAdminList);

export default ConnectedCommunityAdminList;



// WEBPACK FOOTER //
// ./src/community/CommunityAdminList.js